export const columns = (ctx) => {
  return [
    {
      type: 'checkbox',
      visible: true,
      width: '50',
      fixed: 'left',
    },
    // 0512 仅客户名称常驻，故去掉常驻字段  公司代码、公司名称
    {
      field: 'partnerName',
      label: '客户名称',
      title: 'saleInvoice.partnerName',
      visible: true,
      fixed: 'left',
      width: 120,
    },
    {
      field: 'partnerCode',
      label: '客户编码',
      title: 'saleInvoice.partnerCode',
      visible: true,
      width: 160,
    },
    {
      field: 'invoiceStatus',
      label: '单据状态',
      title: '单据状态',
      dictType: 'invoice_status',
      visible: true,
    },
    {
      field: 'expenseTypeCode',
      title: 'saleInvoice.expenseTypeCode',
      visible: true,
      label: '费用类型',
      // dictType: 'expenseType',
    },
    ...(ctx.userInfo.businessGroup == '城矿'
      ? [
          {
            field: 'oaUrl',
            title: '审批详情',
          },
        ]
      : []),
    {
      field: 'goldenTaxDate',
      label: '开票日期',
      title: 'saleInvoice.goldenTaxDate',
      visible: true,
    },
    {
      field: 'invoiceAccountedAmount',
      label: '本币含税总金额',
      title: 'saleInvoice.invoiceAccountedAmount',
      visible: true,
      // format: 'formatAmountRound',
    },
    {
      field: 'invoicedAmount',
      label: '已开票金额',
      title: 'saleInvoice.invoicedAmount',
      visible: true,
      // format: 'formatAmountRound',
    },
    {
      field: 'excludedTaxAmount',
      label: '不含税金额',
      title: 'saleInvoice.excludedTaxAmount',
      visible: true,
      // format: 'formatAmountRound',
    },
    {
      field: 'taxAmount',
      label: '税额',
      width: 100,
      title: 'saleInvoice.taxAmount',
      visible: true,
      // format: 'formatAmountRound',
    },
    {
      field: 'taxRate',
      label: '税率',
      title: 'saleInvoice.taxRate',
      visible: true,
      // format: 'formatAmountRound',
    },
    {
      field: 'businessType',
      label: '业务类别',
      title: '业务类别',
      visible: true,
    },

    {
      field: 'invoiceCompanyCode',
      label: '公司代码',
      title: 'saleInvoice.invoiceCompanyCode',
      visible: true,
      // fixed: 'left',
    },
    {
      field: 'invoiceCompanyName',
      label: '公司名称',
      title: 'saleInvoice.invoiceCompanyName',
      visible: true,
      // fixed: 'left',
      width: 200,
    },
    { field: 'openBankName', label: '开户银行', title: 'saleInvoice.openBankCode', visible: true },
    {
      field: 'bankAccount',
      label: '银行账号',
      title: 'saleInvoice.bankAccount',
      visible: true,
      width: 160,
      format: 'formatBankcard',
    },
    {
      field: 'invoiceNum',
      label: '单据编号',
      title: 'saleInvoice.invoiceNum',
      visible: true,
      width: 160,
    },
    {
      field: 'invoiceType',
      label: '发票类型',
      title: 'saleInvoice.invoiceType',
      dictType: 'invoice_type',
      visible: true,
    },
    {
      field: 'invoiceAmount',
      label: '开票申请金额',
      title: 'saleInvoice.invoiceAmount',
      visible: true,
      // format: 'formatAmountRound',
    },
    {
      field: 'excludedTaxAccountedAmount',
      label: '本位币不含税金额',
      title: 'saleInvoice.excludedTaxAccountedAmount',
      visible: true,
      // format: 'formatAmountRound',
    },
    {
      field: 'taxAccountedAmount',
      label: '本位币税额',
      title: 'saleInvoice.taxAccountedAmount',
      visible: true,
      // format: 'formatAmountRound',
    },
    {
      field: 'currency',
      label: '币种',
      width: 120,
      title: 'saleInvoice.currency',
      visible: true,
      dictType: 'all_currency',
    },
    {
      field: 'exchangeRate',
      label: '汇率',
      width: 120,
      title: 'saleInvoice.exchangeRate',
      visible: true,
    },
    {
      field: 'invoiceCreateDate',
      label: '业务日期',
      width: 120,
      title: 'saleInvoice.invoiceCreateDate',
      visible: true,
    },
    {
      field: 'receivableSettlementNo',
      label: '应收结算单号',
      width: 120,
      title: 'saleInvoice.receivableSettlementNo',
      visible: true,
    },
    {
      field: 'contractNo',
      label: '合同编号',
      width: 120,
      title: 'saleInvoice.contractNo',
      visible: true,
    },
    {
      field: 'projectInitiationNo',
      label: '项目编号',
      width: 120,
      title: 'saleInvoice.projectInitiationNo',
      visible: true,
    },
    {
      field: 'orderCode',
      label: '订单编码',
      title: '订单编码',
      visible: true,
      width: 160,
    },
    {
      field: 'issueStatus',
      label: '开票状态',
      title: 'saleInvoice.issueType',
      visible: true,
      dictType: 'invoiceIssueStatus',
      fixed: 'right',
    },
    // {
    //   field: 'taxRateCode',
    //   label: '税收分类',
    //   width: 120,
    //   title: 'saleInvoice.taxRateCode',
    //   visible: true,
    //   dictType: 'tax_class',
    // },

    // { field: 'belongDate', label: '归属日期', title: 'saleInvoice.belongDate', visible: true },
    // {
    //   field: 'ladingDifferenceAmount',
    //   label: '提单/退货单差异金额合计',
    //   title: 'saleInvoice.ladingDifferenceAmountTotal',
    //   width: 80,
    //   visible: true,
    //   format: 'formatAmountRound',
    // },

    // {
    //   field: 'accountingStatusName',
    //   label: '入账状态',
    //   title: 'saleInvoice.accountingStatus',
    //   visible: true,
    // },
    // {
    //   field: 'voucherNo',
    //   title: '凭证号',
    //   visible: true,
    // },
    // { field: 'accountedDate', label: '入账日期', title: 'saleInvoice.accountedDate', visible: true },
    // {
    //   field: 'invoiceQuantity',
    //   label: '本次开票数量',
    //   title: '本次开票数量',
    //   visible: true,
    //   width: 100,
    // },
    // {
    //   field: 'goldenTaxType',
    //   label: '增值税发票类型',
    //   title: '增值税发票类型',
    //   visible: true,
    //   width: 120,
    //   dictType: 'tax_type',
    // },
  ];
};
